import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '@/logic/break/BreakUtils';

registerCollisionAnimation('GHOST_SOULS', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  for (let i = 0; i < 5; i++) {
    const rnd = seedRandom(e.id, i);
    const angle = rnd * Math.PI * 2;
    const dist = progress * 50;
    const wobble = Math.sin(elapsed * 0.02 + i);
    const x = e.pos.x + Math.cos(angle) * dist + wobble * 10;
    const y = e.pos.y + Math.sin(angle) * dist - progress * 50;

    ctx.fillStyle = determineColor(i, 5);
    ctx.globalAlpha = (1 - progress) * 0.5;
    ctx.beginPath(); ctx.arc(x, y, 6, 0, Math.PI * 2); ctx.fill();
  }
});
